import { useMemo, useState } from 'react';
import { guideEntries } from '../data';
import type { GuideCategory } from '../types';

const categoryLabels: Record<GuideCategory, string> = {
  animals: '草原动物',
  insects: '昆虫和小生命',
  birds: '湿地与草原鸟类',
  geography: '地理小词典'
};

export function FieldGuidePage() {
  const [category, setCategory] = useState<GuideCategory>('animals');
  const entries = useMemo(() => guideEntries.filter((entry) => entry.category === category), [category]);

  return (
    <section className="guide-page">
      <div className="guide-hero">
        <h1>草原图鉴</h1>
        <p>这不是背诵表。它是一套“看到线索，再提出问题”的工具。</p>
      </div>

      <div className="guide-tabs">
        {(Object.keys(categoryLabels) as GuideCategory[]).map((id) => (
          <button className={id === category ? 'active' : ''} key={id} onClick={() => setCategory(id)} type="button">
            {categoryLabels[id]}
          </button>
        ))}
      </div>

      <div className="guide-grid">
        {entries.map((entry) => {
          const Icon = entry.icon;
          return (
            <article className="guide-card" key={entry.id}>
              {entry.image ? (
                <figure>
                  <img src={entry.image} alt={entry.imageAlt} />
                  {entry.imageCredit && <figcaption>{entry.imageCredit}</figcaption>}
                </figure>
              ) : (
                <Icon aria-hidden="true" />
              )}
              <span>{entry.type}</span>
              <h2>{entry.name}</h2>
              <p>{entry.childText}</p>
              <div>
                <b>观察线索</b>
                <p>{entry.signal}</p>
              </div>
              <div>
                <b>家长更多了解</b>
                <p>{entry.deeperText}</p>
              </div>
              <em>{entry.question}</em>
            </article>
          );
        })}
      </div>
    </section>
  );
}
